(function () {
  // AJAX navigation for pills — intercept clicks and call filter-container's ajaxLoadUrl
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-produktart-pill]');
    if (!pill) return;
    e.preventDefault();
    var fc = document.querySelector('filter-container');
    if (fc && fc.dataset.ajaxFiltering === 'true' && fc.ajaxLoadUrl) {
      var orig = window.scrollTo;
      window.scrollTo = function () { window.scrollTo = orig; };
      fc.ajaxLoadUrl(pill.href);
    } else {
      window.location.href = pill.href;
    }
  });

  // Mobile expand / collapse
  document.addEventListener('click', function (e) {
    var mehr = e.target.closest('.produktart-mehr-btn');
    var weniger = e.target.closest('.produktart-weniger-btn');
    if (!mehr && !weniger) return;
    var bar = document.querySelector('.produktart-pills-bar');
    var mehrBtn = document.querySelector('.produktart-mehr-btn');
    var wenigerBtn = document.querySelector('.produktart-weniger-btn');
    if (!bar) return;
    if (mehr) {
      bar.style.maxHeight = '';
      bar.style.overflow = '';
      mehrBtn.hidden = true;
      if (wenigerBtn) wenigerBtn.hidden = false;
    } else {
      var firstPill = bar.querySelector('.produktart-pill');
      if (firstPill) {
        var gap = parseFloat(getComputedStyle(bar).gap) || 6;
        bar.style.maxHeight = (firstPill.offsetHeight * 2 + gap) + 'px';
        bar.style.overflow = 'hidden';
      }
      mehrBtn.hidden = false;
      if (wenigerBtn) wenigerBtn.hidden = true;
    }
  });

  function initMobileCollapse() {
    if (window.innerWidth >= 768) return;
    var bar = document.querySelector('.produktart-pills-bar');
    var mehrBtn = document.querySelector('.produktart-mehr-btn');
    var wenigerBtn = document.querySelector('.produktart-weniger-btn');
    if (!bar || !mehrBtn) return;
    bar.style.maxHeight = '';
    bar.style.overflow = '';
    mehrBtn.hidden = true;
    if (wenigerBtn) wenigerBtn.hidden = true;
    var firstPill = bar.querySelector('.produktart-pill');
    if (!firstPill) return;
    var gap = parseFloat(getComputedStyle(bar).gap) || 6;
    var twoRowH = firstPill.offsetHeight * 2 + gap;
    if (bar.scrollHeight > twoRowH + 4) {
      bar.style.maxHeight = twoRowH + 'px';
      bar.style.overflow = 'hidden';
      mehrBtn.hidden = false;
    }
  }

  // Re-init collapse after AJAX refreshes the pills container
  function watchPillsContainer() {
    var container = document.querySelector('[data-produktart-container]');
    if (!container) return;
    new MutationObserver(function () {
      setTimeout(initMobileCollapse, 0);
    }).observe(container, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initMobileCollapse(); watchPillsContainer(); });
  } else {
    initMobileCollapse();
    watchPillsContainer();
  }
})();
